// extracted by mini-css-extract-plugin
export default {"DashboardTitle":"home_DashboardTitle__5+VQE","headerSection":"home_headerSection__4LVZA","optionSection":"home_optionSection__OpMyH"};